import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate, useLocation } from "react-router-dom";

import { ROLES, bGId, END_USER, APIId } from "common/constants/constants";
import SwiperSteps from "components/common/swiper/SwiperSteps";
import { Form, Formik } from "formik";
import { formatPermissions, handleClaimsParentLevel } from "utils/Utils";
import * as Yup from "yup";

import {
  inviteNewUser,
  inviteNewUserAPI,
} from "services/UserManagementServices";
import { getAllowedUsers } from "services/UserManagementServices";
import { getUserPermissions } from "services/UserManagementServices";
import { getConsultantUsers } from "services/UserManagementServices";
import { getAllBankslist } from "services/bankServices";
import { getBranchNames } from "services/branchServices";
import { getBranchProducts } from "services/branchServices";

import ClaimsInfo from "./ClaimsInfo";
import GeneralInfo from "./GeneralInfo";
import RoleInfo from "./RoleInfo";

import "components/common/parentButton/parentbtn.scss";
import { useTranslation } from "react-i18next";
const AddUser = (props) => {
  const { t } = useTranslation();
  const bankGroupId = bGId;
  const location = useLocation();
  let role = JSON.parse(localStorage.getItem("userRole"))?.roleName;
  let userBankId = localStorage.getItem("bankId");
  let userBranchId = localStorage.getItem("branchId");
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(1);
  const [swiperSteps, setSwiperSteps] = useState([
    {
      id: 1,
      name: t("branch-details"),
      isError: false,
      isCompleted: false,
    },
    {
      id: 2,
      name: t("user-details"),
      isError: false,
      isCompleted: false,
    },
    {
      id: 3,
      name: t("permissions"),
      isError: false,
      isCompleted: false,
    },
  ]);
  // useEffect(() => {

  //   setSwiperSteps((prev) => {
  //     if (location.hash === "#AU") {
  //       return [
  //         ...prev,
  //       ]
  //     } else {
  //       return [
  //         ...prev,

  //       ]
  //     }
  //   })
  // }, [location.hash])
  const [rolesList, setRolesList] = useState([]);
  const [permissionsList, setPermissionsList] = useState([]);
  const [permissionsListBackup, setPermissionsListBackup] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const bankGroupList = [
    location?.hash !== "#AU"
      ? { value: bGId, label: "Genossenschaftsbanken" }
      : { value: null, label: null },
    location?.hash === "#AU"
      ? { value: APIId, label: "Drittanbieter" }
      : { value: null, label: null },
  ];
  const [bankList, setBankList] = useState([]);
  const [bankId, setBankId] = useState(
    role.includes(ROLES.branch_admin) || role.includes(ROLES.branch_consultant)
      ? userBankId
      : ""
  );
  const [branchId, setBranchId] = useState(
    role.includes(ROLES.branch_admin) || role.includes(ROLES.branch_consultant)
      ? userBranchId
      : ""
  );
  const [consultantList, setConsultantList] = useState([]);
  const [branchProducts, setBranchProducts] = useState([]);
  const [rawPermissions, setRawPermissions] = useState([]);
  const [roleVal, setRoleVal] = useState("");
  const [selectedBankName, setSelectedBankName] = useState("");
  const [branchList, setBranchList] = useState([]);
  const [initialValues, setInitialValues] = useState({
    email: "",
    firstName: "",
    companyName: "",
    lastName: "",
    roleId: "",
    bankGroupId: bankGroupId,
    bankId:
      role.includes(ROLES.branch_admin) ||
        role.includes(ROLES.branch_consultant)
        ? userBankId
        : "",
    branchId:
      role.includes(ROLES.branch_admin) ||
        role.includes(ROLES.branch_consultant)
        ? userBranchId
        : "",
    consultantId: "",
    claims: [],
    gender: "",
    consultantHelperName: "",
  });
  const SUPPORTED_FORMATS_IMAGE = ["image/jpg", "image/jpeg", "image/png"];
  const validate = Yup.object({
    companyName:
      location?.hash === "#AU"
        ? Yup.string()
          .required(t("required"))
          .max(50, t("max-name-char-limit-50"))
        : Yup.string(),
    firstName: Yup.string()
      .required(t("required"))
      .max(100, t("max-name-char-limit-100")),
    lastName: Yup.string()
      .required(t("required"))
      .max(100, t("max-name-char-limit-100")),
    email: Yup.string().required(t("required")).email(t("email-error")),
    roleId: Yup.string().required(t("required")),
    branchId:
      location?.hash === "#AU"
        ? Yup.string()
        : Yup.string().required(t("required")),
    bankId:
      location?.hash === "#AU"
        ? Yup.string()
        : Yup.string().required(t("required")),
    bankGroupId:
      location?.hash === "#AU"
        ? Yup.string()
        : Yup.string().required(t("required")),
    claims:
      location?.hash === "#AU"
        ? Yup.array()
        : Yup.array()
          .nullable()
          .test(
            "required",
            t("required"),
            (array) => array?.length && array[0]?.value
          ),
    profilePicture: Yup.mixed().test(
      "fileFormat",
      t("unsupported-format"),
      (value) => {
        let isImgFormat = value && value["type"]?.split("/")[0] === "image";
        return value
          ? isImgFormat && SUPPORTED_FORMATS_IMAGE.includes(value.type)
          : true;
      }
    ),
    gender: Yup.string().required(t("required")),
    consultantHelperName: Yup.string(),
  });
  let totalClaims = [];
  const getAllActiveClaims = (list) => {
    list?.forEach((child) => {
      if (child.value) totalClaims.push(child.claimId);
      if (child.hasOwnProperty("sub")) getAllActiveClaims(child.sub);
    });
  };
  const findConsultantProducts = (consultantId) => {

    const consultant = consultantList.find((ele) => ele?.id === consultantId);
    const { products = "" } = consultant || {};
    return products[0]?.productKey;
  };
  const handleSubmit = async (values, { resetForm }) => {

    let obj = {
      firstName: values.firstName,
      organization: values.companyName,
      phoneNumber: values?.phoneNumber || "",
      lastName: values.lastName,
      email: values.email,
      role: values.roleId,
      branchId: values.branchId,
      bankId: values.bankId,
      consultantId: values.consultantId,
      bankGroupId: bankId ? bankGroupId : "",
      productKey:
        values.roleId === END_USER
          ? findConsultantProducts(values.consultantId)
          : values.consultantProduct,
      claims: [],
      profilePicture: values.profilePicture,
      gender: values.gender,
      consultantHelperName: values.consultantHelperName,
    };

    getAllActiveClaims(permissionsList);

    obj.claims = totalClaims.join(",");

    let formData = new FormData();

    for (let key in obj) {
      formData.append(key, obj[key]);
    }

    setButtonLoading(true);
    let result;
    if (location?.hash !== "#AU") {
      result = await inviteNewUser(formData);
    } else {
      result = await inviteNewUserAPI(formData);
    }
    if (result?.success) {
      setButtonLoading(false);
      navigate(`/user-management/detail/${result?.payLoad?.user?.id}`);
    } else if (result.status === 422) {
      toast.error(t(result?.data?.message));
      setButtonLoading(false);
    } else {
      toast.error(result?.message);
      setButtonLoading(false);
    }
  };

  const handleStepError = (stepId, isError) => {
    setSwiperSteps((prev) => {
      const updatedSteps = prev.map((step) => {
        if (step.id === stepId) {
          step.isError = isError;
        }
        return step;
      });
      return updatedSteps;
    });
  };
  const setProduct = () => {
    if (JSON.parse(localStorage.getItem("userRole"))?.roleName === "#EC") {
      const assignedProductKey = JSON.parse(
        localStorage.getItem("applicationKeys")
      );
      let permissions = [];
      rawPermissions.forEach((permission) => {
        if (!permission.applicationKey.includes("#VdsManagement")) {
          branchProducts.forEach((product) => {
            if (
              permission.applicationKey === product.productKey &&
              assignedProductKey.includes(permission.applicationKey) &&
              product.assigned === "Active"
            ) {
              permissions = [...permissions, permission];
            }
          });
        } else if (permission.applicationKey.includes("#VdsManagement")) {
          permissions = [...permissions, permission];
        }
      });
      let formatedPermission = formatPermissions(permissions);
      setPermissionsListBackup(formatedPermission);

    } else if (
      JSON.parse(localStorage.getItem("userRole"))?.roleName === "#EA"
    ) {
      let formatedPermission = formatPermissions(rawPermissions);
      setPermissionsListBackup(formatedPermission);
    }
  };
  const setConsultant = (value) => {
    let selectedCosultant = consultantList.find((con) => {
      return con.id === value;
    });
    let permissions = [];
    rawPermissions.forEach((permission) => {
      if (!permission.applicationKey.includes("#VdsManagement")) {
        branchProducts.forEach((product) => {
          if (
            permission.applicationKey === product.productKey &&
            (permission.applicationKey ===
              selectedCosultant?.products[0].productKey ||
              (selectedCosultant?.products[0].productKey == "#Gecco" &&
                permission.applicationKey === "#Esg")) &&
            product.assigned === "Active"
          ) {
            permissions = [...permissions, permission];
          }
        });
      } else if (permission.applicationKey.includes("#VdsManagement")) {
        permissions = [...permissions, permission];
      }
    });
    let formatedPermission = formatPermissions(permissions);
    let newPermissions = formatedPermission.filter((el) => {
      return el.type === roleVal && el.parentId === null;
    });
    setPermissionsList(newPermissions);
  };
  const setConsultantProduct = (value) => {
    let permissions = [];
    rawPermissions.forEach((permission) => {
      if (!permission.applicationKey.includes("#VdsManagement")) {
        branchProducts.forEach((product) => {
          if (
            permission.applicationKey === product.productKey &&
            (permission.applicationKey === value ||
              (value == "#Gecco" && permission.applicationKey === "#Esg")) &&
            product.assigned === "Active"
          ) {
            permissions = [...permissions, permission];
          }
        });
      } else if (permission.applicationKey.includes("#VdsManagement")) {
        permissions = [...permissions, permission];
      }
    });
    let formatedPermission = formatPermissions(permissions);
    let newPermissions = formatedPermission.filter((el) => {
      return el.type === "#EC" && el.parentId === null;
    });
    setPermissionsList(newPermissions);
  };
  const handleStepCompletion = (stepId, isCompleted) => {
    setSwiperSteps((prev) => {
      const updatedSteps = prev.map((step) => {
        if (step.id === stepId) {
          step.isCompleted = isCompleted;
        }
        return step;
      });
      return updatedSteps;
    });
  };
  const handleNext = () => {
    setCurrentTab((pre) => pre + 1);
  };
  const handleBack = () => {
    setCurrentTab((pre) => pre - 1);
  };
  const handleJump = (tabId) => {
    setCurrentTab(tabId);
  };

  const getRoles = async () => {
    let resultRoles = await getAllowedUsers();
    if (resultRoles?.success) {
      // if (location.hash === "#AU") {
      //   setRolesList([{
      //     "roleId": "2388C7D0-FD9F-4F09-A20B-BB2117674DA5",
      //     "name": "#AU",
      //     "translatedValue": "Administrator Drittanbieter"
      //   }])
      // } else {
      setRolesList(resultRoles?.payLoad);
      // }
    }
  };
  const branchProductsHandler = async (branchID) => {
    let pathIds = { bankgroupsId: bankGroupId, bankId, branchId: branchID };
    const result = await getBranchProducts(pathIds);
    if (result.success) {
      setBranchProducts(result.payLoad);
      let permissions = [];
      rawPermissions.forEach((permission) => {
        if (!permission.applicationKey.includes("#VdsManagement")) {
          result.payLoad.forEach((product) => {
            if (
              permission.applicationKey === product.productKey &&
              product.assigned === "Active" &&
              (JSON.parse(localStorage.getItem("userRole"))?.roleName !=
                "#EC" ||
                JSON.parse(localStorage.getItem("applicationKeys")).includes(
                  product.productKey
                ))
            ) {
              permissions = [...permissions, permission];
            }
          });
        } else if (permission.applicationKey.includes("#VdsManagement")) {
          permissions = [...permissions, permission];
        }
      });
      let formatedPermission = formatPermissions(permissions);
      setPermissionsListBackup(formatedPermission);
    } else {
    }
  };

  const getPermissions = async () => {
    let resultPermissions = await getUserPermissions();
    if (resultPermissions?.success) {
      setRawPermissions([...resultPermissions.payLoad]);
    }
  };
  const getBankList = async () => {
    let result = await getAllBankslist(bankGroupId);
    if (result?.success) {
      setBankList(result.payLoad);
    }
  };

  const getBranchNameList = async (bankId) => {
    const pathIds = { bankgroupsId: bankGroupId, bankId: bankId };
    let result = await getBranchNames(pathIds);
    if (result?.success) {
      let filteredBranch = [];
      branchId &&
        (filteredBranch = result?.payLoad?.filter(
          (x) => x.branchId === branchId
        ));
      selectedBankName &&
        (filteredBranch = result?.payLoad?.filter(
          (x) => x.branchName === selectedBankName
        ));

      setBranchList(filteredBranch);
      const filteredBranchID = filteredBranch[0]?.branchId;
      if (filteredBranchID) {
        await getConsultantList(filteredBranchID);
        await branchProductsHandler(filteredBranchID);
      }
    }
  };

  const getConsultantList = async (branchId) => {
    const userRole = "%23EC";
    let params = { role: userRole, bankId, branchId };
    const result = await getConsultantUsers(params);
    setConsultantList(result?.payLoad?.items);
  };

  useEffect(() => {
    (async () => {
      await getRoles();
      await getPermissions();
      await getBankList();
    })();
  }, []);

  useEffect(() => {
    bankId && getBranchNameList(bankId);
  }, [bankId]);

  const handleSelectedBank = (bankName) => {
    setSelectedBankName(bankName);
  };
  useEffect(() => {
    rawPermissions.length && branchProducts.length && setProduct();
  }, [rawPermissions, branchProducts]);

  const handleChangeRole = (item) => {
    let newPermissions = permissionsListBackup.filter((el) => {
      return el.type === item.name && el.parentId === null;
    });
    setRoleVal(item.name);
    setPermissionsList(newPermissions);
  };

  const handleChangeClaims = (event, item) => {
    let list = handleClaimsParentLevel(event, item, permissionsList);
    setPermissionsList([...list]);
    setInitialValues({ ...initialValues, claims: [...list] });
  };
  const renderTab = (formik) => {
    if (currentTab === 1) {
      return (
        <RoleInfo
          formik={formik}
          bankGroupList={bankGroupList.filter((item) => item.value !== null)}
          bankList={bankList}
          setBankId={setBankId}
          setBranchId={setBranchId}
          branchList={branchList}
          next={handleNext}
          handleCompletion={handleStepCompletion}
          handleError={handleStepError}
          handleSelectedBank={handleSelectedBank}
          location={location}
        />
      );
    }
    if (currentTab === 2) {
      return (
        <GeneralInfo
          location={location}
          branchProducts={branchProducts}
          formik={formik}
          roles={
            location?.hash === "#AU"
              ? rolesList?.filter((item) => item.name === "#AU")
              : rolesList?.filter((item) => item.name !== "#AU")
          }
          consultantList={consultantList}
          setConsultant={setConsultant}
          setConsultantProduct={setConsultantProduct}
          handleChangeRole={handleChangeRole}
          next={handleNext}
          back={handleBack}
          handleCompletion={handleStepCompletion}
          handleError={handleStepError}
        />
      );
    }
    if (currentTab === 3) {
      return (
        <ClaimsInfo
          location={location}
          formik={formik}
          handleChangeClaims={handleChangeClaims}
          permissions={permissionsList}
          loading={buttonLoading}
          back={handleBack}
          handleCompletion={handleStepCompletion}
          handleError={handleStepError}
        />
      );
    }
  };

  return (
    <>
      <Toaster />
      <Container className="p-md-5 py-xxs-5 px-xxs-2">
        <div className="custom-breadcrumbs ">
          <span
            className="breadcrumbs-item "
            onClick={() => {
              navigate("/user-management");
            }}
          >
            {t("user-management")}
          </span>
          <span className="breadcrumbs-item ">{t("add-user")}</span>
        </div>
        <div className="d-flex justify-content-center">
          <div className="shadow bg-body w-50 pt-3 pb-5 rounded">
            <Formik
              initialValues={initialValues}
              validationSchema={validate}
              onSubmit={(values, { resetForm }) => {
                handleSubmit(values, resetForm);
              }}
            >
              {(formik) => {
                return (
                  <>
                    <SwiperSteps
                      list={swiperSteps}
                      tab={currentTab}
                      maxWidthSwiper={true}
                      back={handleBack}
                      next={handleNext}
                      jump={handleJump}
                    />
                    <Form>
                      <div className="px-5 py-2 ">{renderTab(formik)}</div>
                    </Form>
                  </>
                );
              }}
            </Formik>
          </div>
        </div>
      </Container>
    </>
  );
};

export default AddUser;
